export default "__VITE_ASSET__CHGFRuBI__"